import { useQuery } from 'react-query'

import { CacheKeys } from '../../helpers/cacheKeys'
import { getPerformanceScoreRanges } from '../../models/performance'

export function usePerformanceScoreRanges() {
  const { data } = useQuery(CacheKeys.PERFORMANCE_SCORE_RANGES, () => getPerformanceScoreRanges(), {
    enabled: true,
    refetchOnWindowFocus: false,
    retry: false,
  })

  return {
    performanceScoreRanges: data ?? [],
  }
}
